export const tableShimmer = (shimmer) => {
    if (shimmer)
        return `
                color: #ffffff00;
                * {
                    color: #ffffff00;
                    opacity: 0;
                }

                animation-duration: 2s;
                animation-fill-mode: forwards;
                animation-iteration-count: infinite;
                animation-name: shimmer;
                animation-timing-function: linear;
                &:nth-of-type(even) {
                    background-image: linear-gradient(to right, var(--table-data-row-background-shimmer-odd) 8%,  var(--table-data-row-background-shimmer-shine) 18%, var(--table-data-row-background-shimmer-odd) 33%) !important;
                }
                &:nth-of-type(odd) {
                    background-image: linear-gradient(to right, var(--table-data-row-background-shimmer-even) 8%,  var(--table-data-row-background-shimmer-shine) 18%, var(--table-data-row-background-shimmer-even) 33%) !important;
                }
                background-size: 1200px 100%;
                opacity: 0.4;
                @-webkit-keyframes shimmer {
                        0% {
                            background-position: -100% 0;
                        }
                        100% {
                            background-position: 100% 0;
                        }
                    }

                    @keyframes shimmer {
                        0% {
                            background-position: -1200px 0;
                        }
                        100% {
                            background-position: 1200px 0;
                        }
                    }

        `;
    else return '';
};
